import { createIcon } from '@chakra-ui/react';

export const UploadIconOutline = createIcon({
  displayName: 'UploadIconOutline',
  viewBox: '0 0 26 25',
  path: [
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      key="1"
      d="M15.7857 17.0714V11.5H19.5L13 5L6.5 11.5H10.2143V17.0714H15.7857ZM13 7.62784L15.015 9.64284H13.9286V15.2143H12.0714V9.64284H10.985L13 7.62784ZM19.5 20.7857V18.9286H6.5V20.7857H19.5Z"
      fill="#FF5000"
    />
  ]
});
